import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "grid gap-5 sm:grid-cols-2" }

import { computed, inject, onMounted, ref } from 'vue'

import InputField from '@/components/neue/InputField'
import NeueLoading from '@/components/neue/NeueLoading'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StoreDiscountLimit',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))

const mode = ref('none')
const amount = ref('')
const percentage = ref('')

const load = () => {
  const attrs = store.value.attributes

  if (attrs.max_discount_percentage !== null && attrs.max_discount_percentage !== undefined) {
    mode.value = 'percentage'
    percentage.value = String(attrs.max_discount_percentage)
    amount.value = ''
  } else if (attrs.max_discount_cents !== null && attrs.max_discount_cents !== undefined) {
    mode.value = 'amount'
    amount.value = (attrs.max_discount_cents / 100).toFixed(2)
    percentage.value = ''
  } else {
    mode.value = 'none'
    amount.value = ''
    percentage.value = ''
  }
}

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=none`)
  loading.value = false
  load()
})

const dirty = () => bus.emit('dirty/store', { from: 'discount-limit' })

const handleModeChange = () => {
  amount.value = ''
  percentage.value = ''
  dirty()
}

bus.on('save/store', () => {
  let cents = null
  let pct = null

  if (mode.value === 'amount' && amount.value !== '') {
    const numericAmount = Number(amount.value)
    if (!Number.isNaN(numericAmount)) {
      const fixed = Number(numericAmount.toFixed(2))
      amount.value = fixed.toFixed(2)
      cents = Math.round(fixed * 100)
    }
  } else if (mode.value === 'percentage' && percentage.value !== '') {
    const numericPct = Number(percentage.value)
    if (!Number.isNaN(numericPct)) {
      pct = numericPct
    }
  }

  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      max_discount_cents: cents,
      max_discount_percentage: pct
    }
  })
})

bus.on('discard/store', load)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingsSection, {
          title: "Discount limit",
          description: "Optionally cap the discount an order in this store can receive. Leave it at no limit to apply discounts in full."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(SelectInput), {
                modelValue: mode.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((mode).value = $event)),
                name: "Limit",
                options: [
              { name: 'No limit', value: 'none' },
              { name: 'Enter amount', value: 'amount' },
              { name: 'Enter %', value: 'percentage' }
            ],
                onChange: handleModeChange
              }, null, 8, ["modelValue"]),
              (mode.value === 'amount')
                ? (_openBlock(), _createBlock(_unref(InputField), {
                    key: 0,
                    modelValue: amount.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((amount).value = $event)),
                    name: "Maximum discount amount",
                    prefix: "$",
                    onInput: dirty
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (mode.value === 'percentage')
                ? (_openBlock(), _createBlock(_unref(InputField), {
                    key: 1,
                    modelValue: percentage.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((percentage).value = $event)),
                    name: "Maximum discount percentage",
                    suffix: "%",
                    onInput: dirty
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}